(() => {
  const STORAGE_KEY = 'wishlist:handles:v1';

  const cfg = window.WISHLIST_CONFIG || {};
  const isLoggedIn = Boolean(cfg.loggedIn);
  const loginUrl = cfg.loginUrl || '/account/login';
  const returnUrl = cfg.returnUrl || (window.location.pathname + window.location.search);
  const moneyFormat = cfg.moneyFormat || '{{amount}}';

  // (Optional later) endpoints for account persistence via App Proxy
  const fetchUrl = cfg.fetchUrl || '';
  const syncUrl = cfg.syncUrl || '';

  // Read-only customer metafield value injected by Liquid (stringified JSON)
  const customerWishlistRaw = typeof cfg.customerWishlist === 'string' ? cfg.customerWishlist : '[]';

  const selectors = {
    button: '[data-wishlist-button]',
    count: '[data-wishlist-count]',
    page: '[data-wishlist-page]',
    grid: '[data-wishlist-grid]',
    empty: '[data-wishlist-empty]',
    loading: '[data-wishlist-loading]',
    addToBag: '[data-wishlist-add-to-bag]',
  };

  const TOAST_ID = 'WishlistToast';

  const ensureToast = () => {
    let el = document.getElementById(TOAST_ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = TOAST_ID;
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    document.body.appendChild(el);
    return el;
  };

  let toastTimer = null;

  const showToast = (message) => {
    const el = ensureToast();
    el.textContent = message;
    el.classList.add('is-active');
    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
      el.classList.remove('is-active');
    }, 1800);
  };
  const safeParse = (json, fallback) => {
    try {
      const val = JSON.parse(json);
      return val ?? fallback;
    } catch {
      return fallback;
    }
  };

  const uniq = (arr) => Array.from(new Set((arr || []).filter(Boolean)));

  const getLocal = () => {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = safeParse(raw, []);
    return Array.isArray(parsed) ? parsed : [];
  };

  const setLocal = (handles) => {
    const next = uniq(handles);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { handles: next, count: next.length } })
    );
  };

  const toggle = (handle) => {
    if (!handle) return;
    const list = getLocal();
    const idx = list.indexOf(handle);
    if (idx > -1) list.splice(idx, 1);
    else list.push(handle);
    setLocal(list);
  };

  const addHandle = (handle) => {
  if (!handle) return;
  const list = getLocal();
  if (!list.includes(handle)) {
    list.push(handle);
    setLocal(list);
  }
};

const removeHandle = (handle) => {
  if (!handle) return;
  const list = getLocal();
  const idx = list.indexOf(handle);
  if (idx > -1) {
    list.splice(idx, 1);
    setLocal(list);
  }
};

  const redirectToLogin = () => {
    const url = new URL(loginUrl, window.location.origin);
    url.searchParams.set('return_url', returnUrl);
    window.location.assign(url.toString());
  };

  const updateCount = (count) => {
    const n = Number(count) || 0;
    document.querySelectorAll(selectors.count).forEach((el) => {
      el.textContent = String(n);
      el.hidden = n === 0;
    });
  };

  const updateButtons = (handles) => {
    const set = new Set(handles);
    document.querySelectorAll(selectors.button).forEach((btn) => {
      const handle = btn.getAttribute('data-wishlist-handle');
      if (!handle) return;
      const variantId = btn.getAttribute('data-wishlist-variant');
      const key = variantId ? `${handle}::${variantId}` : handle;
      const active = set.has(key);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

const escapeHtml = (str) => {
  return String(str ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
};

  const formatMoney = (cents) => {
  // Prefer Shopify's formatter when available
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    const formatted = window.Shopify.formatMoney(cents, moneyFormat);

    // If it already contains Rs/₹, keep it; otherwise prefix with "Rs. "
    if (/Rs\./i.test(formatted) || /₹/.test(formatted)) return formatted;
    return `Rs. ${formatted}`;
  }

  // Fallback (cents -> currency)
  const value = (Number(cents || 0) / 100).toFixed(2);
  return `Rs. ${value}`;
};
  function firstRelevantVariant(product) {
  const variants = product?.variants || [];
  return variants.find(v => v.available) || variants[0] || null;
  }

  function calcDiscountPercent(price, compare) {
    if (!compare || compare <= price || compare <= 0) return 0;
    const pct = Math.round(100 - (price * 100 / compare));
    return Math.min(99, Math.max(0, pct));
  }

  function buildSizes(product, optionName, maxSizes) {
    if (!product || !optionName) return '';
    const opts = product.options || [];
    const idx = opts.findIndex(o => String(o).toLowerCase() === String(optionName).toLowerCase());
    if (idx < 0) return '';

    const variants = product.variants || [];
    const values = [];
    variants.forEach(v => {
      const val = v?.options?.[idx];
      if (val && !values.includes(val)) values.push(val);
    });

    const limited = values.slice(0, Math.max(0, Number(maxSizes) || 0));

    const spans = limited.map(val => {
      const anyAvailable = variants.some(v => v?.options?.[idx] === val && v.available);
      return `<span class="wishlist-size ${anyAvailable ? '' : 'is-soldout'}">${escapeHtml(val)}</span>`;
    }).join('');

    return spans ? `<div class="wishlist-sizes">${spans}</div>` : '';
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Failed to fetch product: ${handle}`);
    return await res.json();
  }

  function wishlistCard(p, viewCfg, variantId, entry) {
  let v = null;
  if (variantId) {
    v = (p.variants || []).find((variant) => String(variant.id) === String(variantId)) || null;
  }
  if (!v) v = firstRelevantVariant(p);

  const price = v?.price ?? p.price;
  const compare = v?.compare_at_price ?? null;

  const discountPct = calcDiscountPercent(price, compare);
  const discountBadge = discountPct > 0
    ? `<div class="wishlist-badges-left"><span class="wishlist-badge is-discount">${discountPct}% OFF</span></div>`
    : '';

  const cardImage = (v && v.featured_image && v.featured_image.src)
    ? v.featured_image.src
    : p.featured_image;

  const img = cardImage
    ? `<img src="${cardImage}" alt="${escapeHtml(p.title)}" loading="lazy">`
    : '';

  let colorLabel = '';
  if (v && Array.isArray(p.options) && Array.isArray(v.options)) {
    const colorIdx = p.options.findIndex((o) => /colou?r/i.test(o));
    if (colorIdx > -1 && v.options[colorIdx]) {
      colorLabel = `<p class="wishlist-color-label">${escapeHtml(v.options[colorIdx])}</p>`;
    }
  }

  const cardUrl = v ? `${p.url}?variant=${v.id}` : p.url;
  const removeKey = entry || (variantId ? `${p.handle}::${variantId}` : p.handle);
  const addToBagId = v ? v.id : '';

  const sizesHtml = (viewCfg?.showSizes)
    ? buildSizes(p, viewCfg.sizeOptionName, viewCfg.maxSizes)
    : '';

  const priceHtml = (viewCfg?.showPrice)
    ? `
      <div class="wishlist-price-row">
        <span class="wishlist-price">${formatMoney(price)}</span>
        ${
          (viewCfg?.showCompare && compare && compare > price)
            ? `<span class="wishlist-compare">${formatMoney(compare)}</span>`
            : ''
        }
      </div>
    `
    : '';

  return `
    <li class="wishlist-grid__item">
      <div class="card-wrapper product-card-wrapper">
        <div class="card card--standard card--media">
          <div class="card__inner ratio">
            ${discountBadge}
              <div class="card__media">
                <a class="full-unstyled-link" href="${cardUrl}">
                <div class="media media--transparent">
                  ${img}
                </div>
              </a>
            </div>
          </div>

          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading h5">
                <a class="full-unstyled-link" href="${cardUrl}">${escapeHtml(p.title)}</a>
              </h3>
              ${colorLabel}
              ${sizesHtml}
              ${priceHtml}

              <div class="wishlist-actions">
                <button
                  type="button"
                  class="button button--primary"
                  data-wishlist-add-to-bag
                  data-handle="${p.handle}"
                  data-variant-id="${addToBagId}"
                >
                  Add to bag
                </button>

                <button
                  type="button"
                  class="button button--secondary"
                  data-wishlist-button
                  data-wishlist-handle="${p.handle}"
                  ${variantId ? `data-wishlist-variant="${variantId}"` : ''}
                  aria-pressed="true"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </li>
  `;
}

  async function addToCartFirstAvailable(handle, preferredVariantId) {
  const product = await fetchProduct(handle);
  let variant = null;
  if (preferredVariantId) {
    variant = (product.variants || []).find((v) => String(v.id) === String(preferredVariantId)) || null;
  }
  if (!variant) {
    variant = (product.variants || []).find((v) => v.available) || (product.variants || [])[0];
  }
  if (!variant) throw new Error('No variant');

  const drawer = document.querySelector('cart-drawer');
  const sections = drawer && typeof drawer.getSectionsToRender === 'function'
    ? drawer.getSectionsToRender().map((s) => s.id)
    : null;

  const payload = sections
    ? { id: variant.id, quantity: 1, sections, sections_url: window.location.pathname }
    : { id: variant.id, quantity: 1 };

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  if (!res.ok) throw new Error('Add to cart failed');

  if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
    drawer.renderContents(data);
    return;
  }

  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
    return;
  }

  window.location.assign('/cart');
}

  async function renderWishlistPage() {
    const page = document.querySelector(selectors.page);
    if (!page) return;
    const grid = page.querySelector(selectors.grid);
    const empty = page.querySelector(selectors.empty);
    const loading = page.querySelector(selectors.loading);
    const viewCfg = {
      showPrice: page.dataset.showPrice === 'true',
      showCompare: page.dataset.showCompare === 'true',
      showSizes: page.dataset.showSizes === 'true',
      sizeOptionName: page.dataset.sizeOptionName || 'Size',
      maxSizes: Number(page.dataset.maxSizes || 6)
    };
    if (!grid) return;

    const entries = getLocal();

    if (loading) loading.hidden = false;

    if (!entries.length) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      grid.innerHTML = '';
      return;
    }

    if (empty) empty.hidden = true;

    const parsed = entries.map((entry) => {
      const [handle, variantId] = entry.split('::');
      return { entry, handle, variantId: variantId || null };
    });

    const uniqueHandles = uniq(parsed.map((p) => p.handle));

    try {
      const productList = await Promise.all(uniqueHandles.map(fetchProduct));
      const productMap = {};
      productList.forEach((p, i) => { productMap[uniqueHandles[i]] = p; });

      grid.innerHTML = parsed
        .map((item) => {
          const product = productMap[item.handle];
          if (!product) return '';
          return wishlistCard(product, viewCfg, item.variantId, item.entry);
        })
        .join('');
    } catch {
      grid.innerHTML = `<p class="form__message">Could not load wishlist items. Please refresh.</p>`;
    } finally {
      if (loading) loading.hidden = true;
    }
  }

  // Optional: for later account persistence via App Proxy
  async function fetchRemote() {
    if (!fetchUrl || !isLoggedIn) return [];
    const res = await fetch(fetchUrl, { credentials: 'same-origin' });
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data.handles) ? data.handles : [];
  }

  async function pushRemote(handles) {
    if (!syncUrl || !isLoggedIn) return;
    await fetch(syncUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ handles }),
    });
  }

  async function reconcileOnLogin() {
    if (!isLoggedIn) return;

    const customerHandles = uniq(safeParse(customerWishlistRaw, []));
    const local = uniq(getLocal());
    const merged = uniq([...customerHandles, ...local]);

    if (merged.length !== local.length) setLocal(merged);

    // If proxy is configured later, persist to account:
    if (syncUrl) await pushRemote(merged);

    if (fetchUrl) {
      const remote = uniq(await fetchRemote());
      const merged2 = uniq([...remote, ...getLocal()]);
      setLocal(merged2);
      if (syncUrl) await pushRemote(merged2);
    }
  }

  function onClick(e) {
    const wishBtn = e.target.closest(selectors.button);
    if (wishBtn) {
      e.preventDefault();
      const handle = wishBtn.getAttribute('data-wishlist-handle');
      const variantId = wishBtn.getAttribute('data-wishlist-variant');
      const key = variantId ? `${handle}::${variantId}` : handle;
      const wasInWishlist = getLocal().includes(key);
      if (wishBtn.hasAttribute('data-wishlist-move-to-wishlist')) addHandle(key);
      else toggle(key);
      const isNowInWishlist = getLocal().includes(key);
    if (!wasInWishlist && isNowInWishlist) showToast('Added to wishlist');

      if (wishBtn.hasAttribute('data-wishlist-move-to-wishlist')) {
        const targetId = wishBtn.getAttribute('data-cart-remove-target');
        if (targetId) {
          const removeEl = document.getElementById(targetId);
          const removeBtn = removeEl ? removeEl.querySelector('button') : null;
          if (removeBtn) removeBtn.click();
        }
      }

      return;
    }

    const addBtn = e.target.closest(selectors.addToBag);
    if (addBtn) {
      e.preventDefault();
      const handle = addBtn.getAttribute('data-handle');
      const preferredVariantId = addBtn.getAttribute('data-variant-id');

      addToCartFirstAvailable(handle, preferredVariantId)
        .then(() => removeHandle(handle))
        .catch(() => {
          window.location.assign(`/products/${handle}`);
        });
    }
  }

  function init() {
    document.addEventListener('click', onClick);


    const initial = getLocal();
    updateCount(initial.length);
    updateButtons(initial);
    renderWishlistPage();

    window.addEventListener('wishlist:updated', (e) => {
      updateCount(e.detail.count);
      updateButtons(e.detail.handles);
      renderWishlistPage();

      if (isLoggedIn && syncUrl) pushRemote(e.detail.handles);
    });

    reconcileOnLogin();
    // Shopify theme editor: re-render when section reloads in customizer
    document.addEventListener('shopify:section:load', renderWishlistPage);
    document.addEventListener('shopify:section:select', renderWishlistPage);
  }
  function bindThemeEditorRerender() {
    // Shopify Theme Editor events (only fire in customize mode)
    document.addEventListener('shopify:section:load', renderWishlistPage);
    document.addEventListener('shopify:section:select', renderWishlistPage);
    document.addEventListener('shopify:section:deselect', renderWishlistPage);
  }

  init();
})();